import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_billing_templates_basic_billing_template_form_part = _resolveComponent("billing-templates-basic-billing-template-form-part")!
  const _component_billing_templates_form_field_delivery_policy_type = _resolveComponent("billing-templates-form-field-delivery-policy-type")!
  const _component_billing_templates_email_delivery_policy_form_part = _resolveComponent("billing-templates-email-delivery-policy-form-part")!
  const _component_billing_templates_electronic_delivery_policy_form_part = _resolveComponent("billing-templates-electronic-delivery-policy-form-part")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_billing_templates_basic_billing_template_form_part, {
      modelValue: _ctx.localModel,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModel) = $event)),
      showTemplateName: false
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_delivery_policy_type, {
      modelValue: _ctx.localModel.deliveryPolicyType,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.deliveryPolicyType) = $event))
    }, null, 8, ["modelValue"]),
    (_ctx.localModel.deliveryPolicyType === _ctx.DeliveryPolicyType.Email)
      ? (_openBlock(), _createBlock(_component_billing_templates_email_delivery_policy_form_part, {
          key: 0,
          modelValue: _ctx.localModel.deliveryPolicy,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.deliveryPolicy) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.localModel.deliveryPolicyType === _ctx.DeliveryPolicyType.Electronic)
      ? (_openBlock(), _createBlock(_component_billing_templates_electronic_delivery_policy_form_part, {
          key: 1,
          modelValue: _ctx.localModel.deliveryPolicy,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.deliveryPolicy) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}